module.exports = __webpack_public_path__ + "img/ufo_blue.c2d2ad78.png";